module.exports = __webpack_public_path__ + "img/vi.3e46b23c.svg";